export default [
  { value: "none", label: "Selecionar" },
  { value: "0", label: "0 - Margem Valor Agregado (%)." },
  { value: "1", label: "1 - Pauta (Valor)." },
  { value: "2", label: "2 - Preço Tabelado Máx. (valor)." },
  { value: "3", label: "3 - Valor da operação.." }
];



// WEBPACK FOOTER //
// ./src/core/enum/modbc-values.enum.js